import { Counter } from './counter';

export class ProductPackValidator {
  static getError(counters: Counter[]): string {
    // Hardcoded family validator
    counters = counters ? counters : [];
    const totalCount = counters.reduce((pv, cv) => pv + cv.count, 0);

    if (totalCount < 0) {
      return 'Negative value';
    }

    if (counters.length < 2 || totalCount === 0) {
      return '';
    }

    const findParentCounter = function (): Counter {
      const cs = counters.filter(x => x.familyParentName.indexOf(x.name) > -1);
      return cs.length < 1 ? null : cs[0];
    };

    const findChildrenCounter = function (): Counter {
      const cs = counters.filter(x => x.familyChildrenName.indexOf(x.name) > -1);
      return cs.length < 1 ? null : cs[0];
    };

    let parentsCounter = null;
    let childrenCounter = null;
    parentsCounter = findParentCounter();

    childrenCounter = findChildrenCounter();

    if (parentsCounter == null || childrenCounter == null) {
      return '';
    }

    let isValid = true;

    if (parentsCounter.familyParentsLimit) {
      isValid = parentsCounter.count <= parentsCounter.familyParentsLimit;
    }

    if (childrenCounter.familyChildrenLimit) {
      isValid = childrenCounter.count <= childrenCounter.familyChildrenLimit;
    }

    if (isValid) {
      isValid = parentsCounter.count > 0
        && (childrenCounter.count / parentsCounter.count >= 0.5)
        && (childrenCounter.count + parentsCounter.count >= 3);
    }
    return isValid ? '' : 'Invalid selection!';
  }
}
